import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';

class MembershipValidationRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Membership Validation Request';
        this.Config   = new AppConfig();
        this.route    = null;
    }

    execute(dispatch, payload, route) {
        this.route = route;
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.membershipValidation, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        if(this.response.status) {
            this.dispatch(Actions.setVIPBenefitStatus(true));
            window.open(this.route, 'noopener norefferer');
        }
    }

    onFailure(response, methodName = '') {
        this.dispatch(Actions.setVipErrorMsg(response.message));
    }
}


export default MembershipValidationRequest;